module.exports = __webpack_public_path__ + "img/logo.8de18d0c.png";